/**
 * Plush hover-to-zoom for the main product image (Flipkart-style).
 *
 * Hovering the main image magnifies it and pans toward the cursor by moving the
 * transform-origin. Clicking still opens Dawn's lightbox, so the two coexist.
 *
 * Desktop only — enabled solely for fine pointers with hover, so touch devices
 * (where hover doesn't exist) keep the normal tap-to-lightbox behaviour.
 */
(function () {
  'use strict';

  var ZOOM = 2.2;
  var MEDIA_SELECTOR = '.product__media-wrapper .product__media-item .product__media';

  function bindMedia(media) {
    if (media.dataset.plushZoom === '1') return;
    var img = media.querySelector('img');
    if (!img) return;

    media.dataset.plushZoom = '1';
    media.classList.add('plush-zoom');

    media.addEventListener('mouseenter', function () {
      img.style.transform = 'scale(' + ZOOM + ')';
    });

    media.addEventListener('mousemove', function (event) {
      var rect = media.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      var x = ((event.clientX - rect.left) / rect.width) * 100;
      var y = ((event.clientY - rect.top) / rect.height) * 100;
      // Clamp so the origin never runs past the image edges.
      x = Math.max(0, Math.min(100, x));
      y = Math.max(0, Math.min(100, y));
      img.style.transformOrigin = x + '% ' + y + '%';
    });

    media.addEventListener('mouseleave', function () {
      img.style.transform = '';
      img.style.transformOrigin = 'center center';
    });
  }

  function init() {
    document.querySelectorAll(MEDIA_SELECTOR).forEach(bindMedia);
  }

  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  // Variant changes and section re-renders swap the media out — re-bind on change.
  var wrapper = document.querySelector('.product__media-wrapper');
  if (wrapper && 'MutationObserver' in window) {
    new MutationObserver(init).observe(wrapper, { childList: true, subtree: true });
  }
})();
